import TabGroupBancoDoAuto from '@/components/molecules/TabGroupBancoDoAuto';
import { BancoDoAutoTabs } from '@/data/misc/banco-do-auto-tabs';

export default function FinanciamentoDeMotosPage() {
  return <TabGroupBancoDoAuto tab={BancoDoAutoTabs['financiamento-de-motos'].id} />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
